<template>
  <div :class="{ 'verify-one' : isAuthentication, 'industry-verify-one' : isIndustry }">
    <div class="page-title">{{title}}</div>
    <pageTab :paramsLabel="'type'" :isParams="true" :nowTab="nowTab" :tabs="tab"></pageTab>
    <page-search :layout="searchLayout"  @search="search"></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :titleRows="titleRows"
      :pageIndex="page"
      :pageSize="pageSize"
      @compFn="customCompFunc"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
    <simpleDiag
      @close="close()"
      @confirm="_getVerifyData()"
      :title="titleName"
      :isShow="verifyDiaShow"
      :width="'640'"
    >
      <ul class="page-info-list verify" :class="{'page-info-list__renzheng': isAuthentication}">
        <template v-for="item in this.detailInfo">
          <verifyList
            :info="item"
            :key="item.label"
            :isAuthentication="isAuthentication"
            @lookFull="lookFull"
          ></verifyList>
        </template>
        <li class="page-info-item page-info-item__radio">
          <label class="page-info-tit">{{approvalText}}:</label>
          <span class="page-info-val">
            <RadioGroup v-model="isQualified">
              <Radio :label="1">是</Radio>
              <Radio :label="2">否</Radio>
            </RadioGroup>
            </span>
        </li>
        <!-- 软证书需求2020.02.19 -->
        <!-- 需求：1）推送渠道：天威、源天，默认天威 -->
        <!-- 需求：2）证书选取：默认不直接显示，根据推送渠道联动，当“推送渠道”选择“天威”时，证书选取，默认UKEY，选择“源天”时只有UKEY选项 -->
        <div class="diag-change-content">
          <li class="page-info-item" :class="{'page-info-item__renzheng': isAuthentication}" v-show="isQualified === 1 && isChannel">
            <!-- <label class="page-info-tit">推送渠道:</label> -->
            <label class="page-info-tit">证书渠道:</label>
            <span class="page-info-val page-info-sel">
              <Select v-model="credentialsChannel" placeholder="请选择">
                <Option label="天威" :value="0"></Option>
                <Option label="源天" :value="1"></Option>
              </Select>
            </span>
          </li>
          <li class="page-info-item" :class="{'page-info-item__renzheng__last': isAuthentication}" v-show="isQualified === 1 && isTianWei">
            <span class="page-info-val  page-info-sel">
              <Select v-model="credentialsSearch" placeholder="请选择">
                <Option label="UKEY" :value="0"></Option>
                <Option v-show="isZhengShu" label="软证书" :value="1"></Option>
              </Select>
            </span>
          </li>
          <div class="page-examine-content page-info-item__renzheng" v-show="isAuthentication && !isReject">
            <!-- 只有认证审核才会显示 -->
            <li class="page-info-item">
              <label class="page-info-tit">来源渠道:</label>
              <div class="page-info-val page-info-input">
                <!-- <Input v-model.trim="cayAgentName" placeholder="请输入代理商"></Input> -->
                <Select v-model="t_agent_info_agent_name" placeholder="请选择" @on-change="quudaoSelect">
                  <Option v-for="(item) in qudaoOpts" :label="item.label" :value="item.value" :key="item.value"></Option>
                </Select>
              </div>
            </li>
          </div>
        </div>
        <!-- 复制一份 -->
         <div class="diag-change-content" style="margin-top: 20px;">
          <div class="page-examine-content page-info-item__renzheng" v-show="isAuthentication && !isReject">
            <!-- 只有认证审核才会显示 -->
            <li class="page-info-item">
              <!-- <label class="page-info-tit">代理商:</label> -->
              <label class="page-info-tit">推荐人:</label>
              <div class="page-info-val page-info-input">
                <Input v-model.trim="cayAgentName" placeholder="请输入推荐人" style="width: 210px;"></Input>
              </div>
            </li>
          </div>
        </div>
        <li class="page-info-item" v-show="isReject">
          <label class="page-info-tit page-info-tit__reject">驳回原因:</label>
          <span class="page-info-val" :class="{'page-info-textarea__renzheng': isAuthentication}">
              <Input
                v-model="rejectCause"
                type="textarea"
                placeholder="请输入驳回原因"
                class="page-info-textarea"
                :maxlength="50"
                :autosize="false"
              />
              <span class="textarea-num" :class="{'length-max': rejectCause.length === 50}">{{rejectCause.length}}/50</span>
            </span>
        </li>
      </ul>
      <!-- 会员费 -->
      <!-- 只有认证审核才会显示 -->
      <div class="diag-table-content" v-show="isAuthentication && !isReject">
        <renzheng-table :data="moneySetData" @changeValTips="changeValTips"></renzheng-table>
      </div>
    </simpleDiag>
    <full-diag :isShow="fullImgShow" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <img :src="imgUrl" alt="">
      </div>
    </full-diag>
  </div>
</template>

<script>
import Vue from 'vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageTab from '@/components/pageCom/pageTab.vue'
import fullDiag from '@/components/dialogs/fullDiag'
import simpleDiag from '@/components/dialogs/simpleDiag'
import verifyMixin from './components/verifyMixin'
import verifyList from './components/verifyList'
import { getDetailVerify, getVerifyAmount, getUkeyVerify } from '@/api/app'
import { getChannelOpts } from '@/api/channel'
import renzhengTable from './components/renzhengTable.vue'
export default {
  name: 'verify',
  components: {
    approvalText: '审批通过',
    pageSearch,
    simpleDiag,
    fullDiag,
    pageTab,
    pageTable,
    verifyList,
    renzhengTable
  },
  mixins: [pageTableMixin, verifyMixin],
  data() {
    return {
      businessCategory: '', // 经营范围
      isChannel: true, // 渠道
      imgUrl: '', // 查看图片弹窗的url
      isTianWei: true, // 是否选中天威
      isZhengShu: true, // 是否选中天威
      isReject: false, // 驳回原因是否显示
      isAuthentication: true, // 判断是否是认证审核 用于更改列表无数据的样式
      isUkey: true, // 判断是否是ukey审核 用于更改列表无数据的样式
      isIndustry: true, // 判断是工业 还是服务商
      verifyDiaShow: false, // 审核弹窗是否开启
      titleName: '', // 对话框的表头
      fullImgShow: false, // 查看图片弹窗是否开启
      cayId: '', // 企业ID
      isQualified: 1, // 是否通过
      credentialsChannel: 0, // 证书渠道
      credentialsSearch: 0, // 证书选取
      t_agent_info_agent_name: '', // 21-2-1 新增推荐渠道
      t_agent_info_agent_name_edit: '', // 针对弹框 保留原始值
      t_agent_info_uuid: '', // 对应渠道的uuid
      cayAgentName: '', // 代理商名称
      rejectCause: '', // 驳回原因
      searchLayout: ['code', 'name', 't_agent_info_agent_name'],
      tab: [
        { linkName: '1', text: '认证信息审核', num: '0' },
        { linkName: '2', text: 'UKey申请审核', num: '0' },
        { linkName: '3', text: '软证书申请审核', num: '0' }
      ],
      nowTab: '1',
      title: '',
      col: [],
      titleRows: [],
      searchParams: { // search参数
        corpTypeKey: '', // 1 工业 2 服务商
        confirmType: '', // 1 认证信息 2 Ukey 3软证书
        cayNo: '',
        cayName: '',
        t_agent_info_agent_name: ''
      },
      detailInfo: [], // dialog需要展示的数据
      moneySetData: [],
      examineCayNo: '', // 公司编码(认证审核时候用)，取cay_no
      currentExamineData: {}, // 当前审核的数据（切换审核通过-是否的时候赋值使用
      qudaoOpts: []
    }
  },
  watch: {
    'isQualified'(to) {
      if (to.toString() === '1') {
        this.initMoneyData(this.currentExamineData)
        this.isReject = false
        this.rejectCause = '' // 清空驳回原因
      } else {
        this.isReject = true
        this.cayAgentName = ''
        this.t_agent_info_agent_name = this.t_agent_info_agent_name_edit
      }
    },
    // 审核-推送渠道
    'credentialsChannel'(to) {
      if (to.toString() === '0') {
        this.isTianWei = true
        this.isZhengShu = true
      } else {
        this.credentialsSearch = 0
        this.isZhengShu = false
      }
    }
  },
  methods: {
    initPage() { // 这里需要将搜索参数清空
      Object.keys(this.searchParams).forEach(item => {
        this.searchParams[item] = ''
      })
      if (this.$route.name === 'industryVerify') {
        this.title = '工业列表'
        this.searchParams.corpTypeKey = '1'
        this.isIndustry = true
      } else if (this.$route.name === 'serverVerify') {
        this.title = '服务商列表'
        this.searchParams.corpTypeKey = '2'
        this.isIndustry = false
      }
      this.getTabNum()
      if (this.$route.params.type.toString() === '1') {
        // 认证信息审核
        this.searchParams.confirmType = '1'
        this.isUkey = false
        this.isAuthentication = true
        this.titleName = '认证审核'
        this.approvalText = '审批通过'
        this.isChannel = true
        this.isTianWei = true
        if (this.$route.name === 'industryVerify') {
          this.col = this.industryCol
          this.titleRows = this.industryTitleRows
        } else if (this.$route.name === 'serverVerify') {
          this.col = this.serverCol
          this.titleRows = this.serverTitleRows
        }
      } else if (this.$route.params.type.toString() === '2') {
        // UKEY审核
        this.isChannel = false
        this.isTianWei = false
        this.searchParams.confirmType = '2'
        this.isUkey = true
        this.isAuthentication = false
        this.titleName = 'UKey申请审核'
        this.approvalText = '审批通过'
        this.col = this.newUkeyCol
        this.titleRows = []
      } else {
        // 软证书审核
        this.isChannel = false
        this.isTianWei = false
        this.approvalText = '纸质材料是否合格'
        this.searchParams.confirmType = '3'
        this.isUkey = false
        this.isAuthentication = false
        this.titleName = '软证书申请审核'
        this.col = this.ruanZhengShuCol
        this.titleRows = []
      }
    },
    // 获取认证审核数量
    getTabNum() {
      this.nowTab = this.$route.params.type.toString()
      getVerifyAmount({
        corp_type_key: this.searchParams.corpTypeKey
      }).then(res => {
        if (res.code === 0) {
          this.tab[0].num = res.result.confirm1
          this.tab[1].num = res.result.confirm2
          this.tab[2].num = res.result.confirm3
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tab[0].num = 0
          this.tab[1].num = 0
          this.tab[2].num = 0
        }
      })
    },
    // 显示/隐藏tips提示
    changeValTips(index, indexChildren, type) {
      this.moneySetData[index].data[indexChildren].showTips = type
    },
    // 获取认证审核列表
    getData() {
      this.tableLoading = true
      getDetailVerify({
        corp_type_key: this.searchParams.corpTypeKey,
        confirm_type: this.searchParams.confirmType,
        cay_no: this.searchParams.cayNo,
        cay_name: this.searchParams.cayName,
        t_agent_info_agent_name: this.searchParams.t_agent_info_agent_name,
        current_page: this.page,
        rp: this.pageSize
      }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data
          this.total = res.result.count
          const { result } = res
          if (this.searchParams.confirmType.toString() === '1') {
            this.tab[0].num = result.count
          } else if (this.searchParams.confirmType.toString() === '2') {
            this.tab[1].num = result.count
          } else {
            this.tab[2].num = result.count
          }
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tableData = []
          this.total = 0
        }
      })
    },
    toggleFullImg(flag) {
      this.fullImgShow = flag
    },
    // 查看图片弹窗
    lookFull(src) {
      this.imgUrl = src
      this.fullImgShow = true
    },
    // 打开审核弹窗
    customCompFunc(data) {
      if (data.type === 'verify') {
        this.cayId = data.cayId // 企业ID
        this.verifyDiaShow = true
        this.t_agent_info_agent_name = data.t_agent_info_agent_name || ''
        this.t_agent_info_agent_name_edit = data.t_agent_info_agent_name || ''
        this.t_agent_info_uuid = data.t_agent_info_uuid
        // 获取渠道下拉选项
        this.getQudaoOpt()
        // 自己增加的代码
        this.detailInfo = []
        if (!this.isUkey && this.isAuthentication) {
          this.examineCayNo = data.cayNo
          // 认证审核
          let arr = [
            { type: 'info', label: '用户编码', value: data.cayNo },
            // { type: 'info', label: '企业名称', value: data.cayName },
            { type: 'img', label: '营业执照', imgName: data.businessLicenseUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API).split('image/')[1], value: data.businessLicenseUrl, name: data.cayName },
            { type: 'info', label: '企业名称', value: data.cayName }
          ]
          if (!this.isIndustry) {
            arr.push({ type: 'info', label: '经营类目', value: data.businessCategory })
          }
          if (data.certificateType === '1') {
            const arr2 = [
              { type: 'img', label: '组织机构代码证', value: data.organizationCodeUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName },
              { type: 'img', label: '税务登记号', value: data.taxPhotoUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName }
            ]
            arr = arr.concat(arr2)
          }
          arr.forEach(item =>
            this.detailInfo.push(item)
          )
          this.currentExamineData = data // 设置当前审核的数据
          this.initMoneyData(data) // 设置价格初始值
        } else if (this.isUkey) {
          // UKEY审核
          const arr = [
            { type: 'info', label: '用户编码', value: data.cayNo },
            { type: 'info', label: '企业名称', value: data.cayName },
            { type: 'img', label: '授权书', value: data.certificateImgUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName },
            { type: 'img', label: '公司公章', value: data.signatureImgUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName }
          ]
          arr.forEach(item => {
            this.detailInfo.push(item)
          })
        } else {
          // 软证书审核
          const arr = [
            { type: 'info', label: '用户编码', value: data.cayNo },
            { type: 'info', label: '企业名称', value: data.cayName },
            { type: 'img', label: '授权书', value: data.certificateImgUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName },
            { type: 'img', label: '公司公章', value: data.signatureImgUrl.replace(process.env.VUE_APP_PIC, process.env.VUE_APP_BASE_API), name: data.cayName }
          ]
          arr.forEach(item => {
            this.detailInfo.push(item)
          })
        }
      } else if (data.type === 'lookDetail') {
        // 查看明细跳转
        const jumpLink = {
          name: this.$route.name === 'industryVerify' ? 'detailVerifyIndustry' : 'detailVerifyServer',
          params: {
            id: this.$route.params.type.toString()
          },
          query: {
            cayNo: data.cayNo
          }
        }
        this.$router.push(jumpLink)
      } else if (data.type === 'certificateUrl') {
        if (!data.certificateImgUrl) {
          this.$Message.info('图片未找到')
          return false
        }
        this.imgUrl = data.certificateImgUrl
        this.fullImgShow = true
      } else if (data.type === 'signatureUrl') {
        if (!data.signatureImgUrl) {
          this.$Message.info('图片未找到')
          return false
        }
        this.imgUrl = data.signatureImgUrl
        this.fullImgShow = true
      }
    },
    // 设置价格初始值
    initMoneyData(result) {
      this.moneySetData = [
        { // 会员费用
          label: '会员费用',
          labelWidth: 55,
          col: [
            { field: 'type', title: '会员类型', width: 220, titleAlign: 'left', columnAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 130, titleAlign: 'left', columnAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 178, titleAlign: 'left', columnAlign: 'left' }
          ],
          data: [
            { type: '初级会员', min: 5000, max: 20000, money: '', val: '', showTips: false },
            { type: '中级会员', min: 20000, max: 50000, money: '', val: '', showTips: false },
            { type: '高级会员', min: 50000, max: 100000, money: '', val: '', showTips: false }
            // { type: '初级会员', min: 0.01, max: 20000, money: '', val: '', showTips: false },
            // { type: '中级会员', min: 0.02, max: 50000, money: '', val: '', showTips: false },
            // { type: '高级会员', min: 0.03, max: 100000, money: '', val: '', showTips: false }
          ]
        },
        { // 流量费用
          label: '流量费用',
          labelWidth: 55,
          col: [
            { field: 'type', title: '流量类型', width: 220, titleAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 130, titleAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 178, titleAlign: 'left' }
          ],
          data: [
            { type: '调研次数', min: 500, max: 2000, money: '', val: '', showTips: false },
            { type: '基础报告', min: 400, max: 2000, money: '', val: '', showTips: false },
            { type: '直播场次', min: 100, max: 500, money: '', val: '', showTips: false }
          ]
        }
      ]
      // 会员费用基准价格、优惠后费用 赋值
      const vieData = result.hy_list_std.map(item => {
        return item.hy_level_money
      })
      this.moneySetData[0].data.map((item, index) => {
        item.money = vieData[index]
        item.val = vieData[index] || '' // 优惠后费用默认为标准价格
        // item.val = vieData[index] === '' ? '' : Number(vieData[index]).toFixed(2)
      })
      // end
      // 流量费用基准价格、优惠后费用 赋值
      const flowData = [result.coupon_money_std.money_config_report, result.coupon_money_std.money_config_base_report, result.coupon_money_std.money_config_live]
      this.moneySetData[1].data.map((item, index) => {
        item.money = flowData[index]
        item.val = flowData[index] || '' // 优惠后费用默认为标准价格
        // item.val = flowData[index] === '' ? '' : Number(flowData[index]).toFixed(2)
      })
      // end
    },
    // 关闭审核弹窗
    close() {
      this.verifyDiaShow = false
      setTimeout(() => {
        this.rejectCause = ''
        this.isQualified = 1
        this.credentialsChannel = 0
        this.credentialsSearch = 0
        this.cayAgentName = '' // 代理商清空
        this.t_agent_info_agent_name = ''
      }, 200)
    },
    // 搜索的参数
    search(query) {
      this.initTable()
      this.searchParams.cayNo = query.code
      this.searchParams.cayName = query.name
      this.searchParams.t_agent_info_agent_name = query.t_agent_info_agent_name
      this.getData()
    },
    // 提交审核
    _getVerifyData() {
      let req = {
        cay_id: this.cayId,
        confirm_type: this.searchParams.confirmType === '3' ? '2' : this.searchParams.confirmType,
        edit_type: this.isQualified
      }
      if (Number(this.isQualified) === 1) {
        // 是
        req.platform_flag = this.credentialsChannel // 推送渠道，0天威，1源天
        req.license_type = this.credentialsSearch // 证书类型 0UKEY 1软证书
        req.t_agent_info_agent_name = this.t_agent_info_agent_name // 推荐渠道
        req.t_agent_info_uuid = this.t_agent_info_uuid // 渠道uuid
      } else {
        req.cay_approval_opinion = this.rejectCause // 驳回原因
      }
      if (this.isAuthentication) {
        const paramsData = this.moneySetData
        // if (!this.cayAgentName) {
        //   this.$Message.info('代理商不能为空')
        //   return
        // }
        paramsData[0].data.map(item => {
          if (item.val === '' || item.val < item.min || item.val > item.max) {
            item.showTips = true
          }
        })
        paramsData[1].data.map(item => {
          if (item.val === '' || item.val < item.min || item.val > item.max) {
            item.showTips = true
          }
        })
        if (Number(this.isQualified) === 1) {
          // 判断填写的价格区间是否正确
          const vipCloseTips = paramsData[0].data.some(item => item.showTips)
          const flowCloseTips = paramsData[1].data.some(item => item.showTips)
          if (vipCloseTips || flowCloseTips) {
            this.$Message.info('请填写正确的价格')
            return
          }
        }
        const examineData = {
          hy_level1_price_sale: paramsData[0].data[0].val, // 初级会员优惠后的价格
          hy_level2_price_sale: paramsData[0].data[1].val, // 中级会员优惠后的价格
          hy_level3_price_sale: paramsData[0].data[2].val, // 高级会员优惠后的价格
          diaoyan_price_sale: paramsData[1].data[0].val, // 调研优惠游的价格
          report_price_sale: paramsData[1].data[1].val, // 报告优惠后的价格
          live_price_sale: paramsData[1].data[2].val, // 直播优惠后的价格
          cay_agent_name: this.cayAgentName // 代理商
        }
        if (Number(this.isQualified) === 1) {
          req = { ...req, ...examineData }
        }
        const cust_no = { cust_no: this.examineCayNo }
        req = { ...req, ...cust_no }
      }
      getUkeyVerify(req).then(res => {
        if (res.code === 0) {
          this.rejectCause = ''
          this.getData()
          this.$Message.success('提交成功')
          this.verifyDiaShow = false
          this.isQualified = 1
          this.cayAgentName = '' // 代理商清空
          this.t_agent_info_agent_name = ''
          this.credentialsChannel = 0
          this.credentialsSearch = 0
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    getQudaoOpt() { // 获取渠道下拉
      getChannelOpts().then(res => {
        if (res.code === 0) {
          this.qudaoOpts = res.result.map(obj => {
            return {
              value: obj.t_agent_info_agent_name,
              label: obj.t_agent_info_agent_name,
              uuid: obj.t_agent_info_uuid
            }
          })
        }
      })
    },
    quudaoSelect(val) {
      const tmpArr = this.qudaoOpts.filter(obj => {
        return obj.value === val
      })
      if (tmpArr.length) {
        this.t_agent_info_uuid = tmpArr[0].uuid
      } else {
        this.t_agent_info_uuid = ''
      }
    }
  }
}
Vue.component('operateVerify', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    verify() {
      const verifyData = {
        type: 'verify',
        businessLicenseUrl: this.rowData.cay_business_license_url,
        organizationCodeUrl: this.rowData.cay_organization_code_certificate_url,
        taxPhotoUrl: this.rowData.cay_tax_registration_alone_url,
        certificateType: this.rowData.cay_certificate_type,
        signatureImgUrl: this.rowData.cay_official_seal_url, // 公司公章
        certificateImgUrl: this.rowData.cay_certificate_url, // 授权书
        businessCategory: this.rowData.business_category,
        cayNo: this.rowData.cay_no,
        cayName: this.rowData.cay_name,
        cayId: this.rowData.cay_id,
        coupon_money_std: this.rowData.coupon_money_std || {}, // 流量标准费用
        hy_list_std: this.rowData.hy_list_std || [], // 会员标准费用
        t_agent_info_agent_name: this.rowData.t_agent_info_agent_name || '',
        t_agent_info_uuid: this.rowData.t_agent_info_uuid || ''
      }
      this.$emit('on-custom-comp', verifyData)
    },

    list() {
      const verifyData = {
        type: 'lookDetail',
        cayNo: this.rowData.cay_no
      }
      this.$emit('on-custom-comp', verifyData)
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.list
      }
    }, '查看明细'), h('a', {
      on: {
        click: this.verify
      }
    }, '审核')])
  }
})
Vue.component('certificateUrl', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    verify() {
      const verifyData = {
        type: 'certificateUrl',
        certificateImgUrl: this.rowData.cay_certificate_url
      }
      this.$emit('on-custom-comp', verifyData)
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        lookImg: true
      }
    }, [h('a', {
      on: {
        click: this.verify
      }
    }, '授权书.jpg')])
  }
})
Vue.component('signatureUrl', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    verify() {
      const verifyData = {
        type: 'signatureUrl',
        signatureImgUrl: this.rowData.cay_official_seal_url
      }
      this.$emit('on-custom-comp', verifyData)
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        lookImg: true
      }
    }, [h('a', {
      on: {
        click: this.verify
      }
    }, '签章.jpg')])
  }
})
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.page-info-list__renzheng {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .ivu-modal .ivu-modal-body {
    padding: 20px 20px 24px 20px;
  }
  /deep/.page-info-item {
    padding: 0 !important;
    font-size: 12px;
    color: $fontBlack;
    line-height: 18px;
    &:last-child {
      padding-top: 0;
    }
  }
  /deep/ .page-info-tit {
    width: 55px !important;
  }
}
.page-info-textarea {
  width: 200px;
}
.page-info-textarea__renzheng {
  max-width: unset !important;
  .page-info-textarea {
    width: 535px;
  }
}
.page-info-item__renzheng {
  .page-info-tit {
    line-height: 28px;
  }
  &__last {
    margin-left: 10px;
    margin-right: 25px;
  }
  .page-info-input {
    width: 220px;
  }
  /deep/ .ivu-input {
    border-radius: 2px;
  }
}
/deep/ .ivu-select-dropdown {
  width: 100% !important;
}
/deep/ .ivu-select-selection {
  border-radius: 2px;
}
.page-info-sel {
  width: 100px;
}
.page-info-tit__reject {
  margin-top: 10px;
}
.diag-change-content {
  & > li,
  & > div {
    display: inline-block;
  }
}
.page-info-item__radio {
  margin-bottom: 20px;
}
/deep/ .ivu-modal {
  top: 0 !important;
}
// .page-info-item:last-child
</style>
<style lang="scss">
@import '@/styles/color.scss';
  .vertical-center-modal .ivu-modal-close .ivu-icon-ios-close {
    background: url("../../assets/icon.svg") no-repeat -354px -134px;
  }
  .length-max {
    color: $tipsColor !important;
  }
</style>

